import { StorageCategories } from 'app/services/database/storage.service';

export class FileModel {
    public id: string;
    public name: string;
    public size: number;
    public category: StorageCategories;
    public url: string;

    constructor(model?: Partial<FileModel>) {
        Object.assign(this, model);
    }
}

export class FileModelBuilder extends FileModel {
    public file: File | Blob;

    constructor(model?: Partial<FileModelBuilder>, generateBase64Url = false) {
        super();
        Object.assign(this, model);

        if (this.file && generateBase64Url) {
            let reader = new FileReader();
            reader.onload = (event: any) => {
                this.url = event.target.result;
            };
            reader.readAsDataURL(this.file);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/models/file.model.ts